<lib-form-field-container 
    [kind]="FormContainerKind.None">

    <ng-content label select="[label]"></ng-content> 

    <ng-content supportingText select="[supportingText]"></ng-content>

    <ng-container readOnly>
        <div #providedReadOnly class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">{{ formControl.value }}</div>
    </ng-container>

    <lib-checkbox [formControl]="form.controls.SelectAll"
        [isIndeterminate]="isIndeterminate"
        (change)="SelectAll($event)">
        {{selectAllLabel}}
        ({{itemQueryList.length}})
    </lib-checkbox>

    @for (item of itemQueryList; track item.value; let i = $index) {
        <lib-checkbox class="padding-left-28"
            [formControl]="viewControl.controls[i]"
            [isLoading]="isLoading"
            [qaTag]="item.qaTag"
            (change)="ChangeEvent($event, i)">
            <ng-container checkboxSupportingText *ngTemplateOutlet="item.supportingText"></ng-container>
            <ng-container *ngTemplateOutlet="item.label"></ng-container>
        </lib-checkbox>
    }

</lib-form-field-container>